import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  PropertyUsp1xPhotoInitModel,
  PropertyUsp1xPhotoInitVariables,
  PropertyUsp1xPhotoModel,
  PropertyUsp1xPhotoVariables,
} from '../../../../../models/email-template/property-usp-1x-photo.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-propertyusp1xphoto',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent
    ],
    templateUrl: './property-usp-1x-photo.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './property-usp-1x-photo.component.scss'
})
export class PropertyUsp1xPhotoComponent extends BaseComponent implements OnInit {
  @Input() block: PropertyUsp1xPhotoModel = new PropertyUsp1xPhotoInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new PropertyUsp1xPhotoInitVariables()
    }
  }

  //placeholders:
  imageDesktopPlaceholder: string = 'Desktop Image';
  imageMobilePlaceholder: string = 'Mobile Image';
  imageHrefPlaceholder: string = 'Enter Image Redirect Link';
  imageAltPlaceholder: string = 'Enter Image Alt Text';
  namePlaceholder: string = 'Enter Property Name';
  usp1Placeholder: string = 'Enter USP 1';
  usp2Placeholder: string = 'Enter USP 2';
  usp3Placeholder: string = 'Enter USP 3';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof PropertyUsp1xPhotoVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof PropertyUsp1xPhotoVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
